import { MenuItemGroup } from '@rematter/modules/settings/_types';
import { settingsRouteGroups } from '@rematter/modules/settings/routes';
import { Col, Row, cn } from '@rematter/ui-web';
import { LucideSearch } from 'lucide-react';

import { useTranslations } from '../../i18n/useTranslations';

import { MenuGroup } from './MenuGroup';

const MenuSearchField = ({
  className,
  ...props
}: Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>) => (
  <Row
    className={cn(
      '@MenuSearchField rounded border border-transparent bg-current/7 px-2 py-1.5 text-sm outline-[3px] outline-transparent transition-all',
      'focus-within:border-primary focus-within:bg-space focus-within:outline-primary/20',
      className,
    )}
    gap2
    yCenter
  >
    <LucideSearch className="size-4 shrink-0 opacity-50" />
    <input
      type="text"
      {...props}
      className="border-none bg-transparent p-0 outline-none placeholder:text-current/40"
    />
  </Row>
);

export const SettingsMenu = () => {
  const t = useTranslations();
  const menuGroups = settingsRouteGroups as MenuItemGroup[];

  return (
    <Col className="@SettingsMenu w-[220px] p-3" gap3>
      <MenuSearchField placeholder={t.settingsLayout.search} />

      <Col gap3>
        {menuGroups.map((group, i) => (
          <MenuGroup
            key={`${i}_${group.groupTitle ?? group.items.at(0)?.pattern}`}
            group={group}
            index={i}
          />
        ))}
      </Col>
    </Col>
  );
};
